import api from './client';
import { forEach, size } from 'constants/lodash';

export const uploadFactionData = (sectorId, factions) => {
  if (!size(factions)) return Promise.resolve();
  const requests = [];
  forEach(factions, (faction, id) => requests.push(api(`/resources/${sectorId}/factions/${id}`, { method: 'PUT', body: faction })));
  return Promise.all(requests);
};
export const createFaction = (sectorId, faction) => api(`/resources/${sectorId}/factions`, { method: 'POST', body: faction });
export const editFaction = (sectorId, factionId, faction) => api(`/resources/${sectorId}/factions/${factionId}`, { method: 'PUT', body: faction });
export const deleteFaction = (sectorId, factionId) => api(`/resources/${sectorId}/factions/${factionId}`, { method: 'DELETE' });
export const getFactionData = sectorId => api(`/sectors/${sectorId}`).then(({ factions }) => factions);
